export default __webpack_public_path__ + "static/media/con_trim03.8330cd26.jpg";